import { Routes } from '@angular/router';
import { LayoutComponent } from './views/admin/layout/layout.component';
import { AcademicYearClosureComponent } from './views/admin/pages/configurations/academic-year-closure/academic-year-closure.component';
import { AcademicYearComponent } from './views/admin/pages/configurations/academic-year/academic-year.component';
import { AgendaComponent } from './views/admin/pages/configurations/agenda/agenda.component';
import { CategoryInformationComponent } from './views/admin/pages/configurations/category-information/category-information.component';
import { CycleComponent } from './views/admin/pages/configurations/cycle/cycle.component';
import { PeriodComponent } from './views/admin/pages/configurations/period/period.component';
import { RoomComponent } from './views/admin/pages/configurations/room/room.component';
import { SchoolComponent } from './views/admin/pages/configurations/school/school.component';
import { SettingComponent } from './views/admin/pages/configurations/setting/setting.component';
import { StopNoteComponent } from './views/admin/pages/configurations/stop-note/stop-note.component';
import { UsefulInformationComponent } from './views/admin/pages/configurations/useful-information/useful-information.component';
import { LoginComponent } from './views/admin/pages/auth/login/login.component';
import { HomeComponent } from './views/admin/pages/home/home.component';
import { HomeComponent as HomeProfessor } from './views/professor-module/pages/home/home.component';
import { LayoutComponent as LayoutProfessor } from './views/professor-module/layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { VerifyAccountStateGuard } from './core/guards/verify-account-state.guard';
import { CourseComponent } from './views/admin/pages/configurations/course/course.component';
import { PermissionComponent } from './views/admin/pages/auth/permission/permission.component';
import { ProfileComponent } from './views/admin/pages/auth/profile/profile.component';
import { RoleComponent } from './views/admin/pages/auth/role/role.component';
import { UserProfilComponent } from './views/admin/pages/auth/user-profil/user-profil.component';
import { UserSettingComponent } from './views/admin/pages/auth/user-setting/user-setting.component';
import { UserComponent } from './views/admin/pages/user/user.component';
import { WindowsComponent } from './views/admin/pages/windows/windows.component';
import { PollComponent } from './views/admin/pages/configurations/poll/poll.component';
import { ClassroomPassationComponent } from './views/admin/pages/configurations/classroom-passation/classroom-passation.component';
import { ClassroomTypeFeeComponent } from './views/admin/pages/configurations/classroom-type-fee/classroom-type-fee.component';
import { LevelComponent } from './views/admin/pages/configurations/level/level.component';
import { TypeFeeComponent } from './views/admin/pages/configurations/type-fee/type-fee.component';
import { PersonalComponent } from './views/admin/pages/configurations/personal/personal.component';
import { FeatureComponent } from './views/admin/pages/feature/feature.component';
import { ClassroomComponent } from './views/admin/pages/configurations/classroom/classroom.component';
import { TemplateComponent } from './views/admin/pages/configurations/template/template.component';
import { InqueryDetailsComponent } from './views/admin/pages/Inqueries/inquery-details/inquery-details.component';
import { InqueryIndexComponent } from './views/admin/pages/Inqueries/inquery-index/inquery-index.component';
import { InqueryParcoursComponent } from './views/admin/pages/Inqueries/inquery-parcours/inquery-parcours.component';
import { InscriptionValidationComponent } from './views/admin/pages/inscriptions/inscription-validation/inscription-validation.component';
import { InscriptionCreateComponent } from './views/admin/pages/inscriptions/inscription-create/inscription-create.component';
import { InscriptionDetailComponent } from './views/admin/pages/inscriptions/inscription-detail/inscription-detail.component';
import { InscriptionRenewDetailsComponent } from './views/admin/pages/inscriptions/inscription-renew-details/inscription-renew-details.component';
import { InscriptionRenewComponent } from './views/admin/pages/inscriptions/inscription-renew/inscription-renew.component';
import { InscriptionComponent } from './views/admin/pages/inscriptions/inscription/inscription.component';
import { StudentComponent } from './views/admin/pages/student/student.component';
import { IsAuthedGuard } from './core/guards/is-authed.guard';
import { IsVerifiedAccountStateGuard } from './core/guards/is-verified-account-state.guard';
import { AccountActivationComponent } from './views/admin/pages/auth/account-activation/account-activation.component';
import { ForgetPasswordComponent } from './views/admin/pages/auth/forget-password/forget-password.component';
import { RecoveryPasswordComponent } from './views/admin/pages/auth/recovery-password/recovery-password.component';
import { NotFoundComponent } from './views/not-found-component/not-found-component.component';
import { NoteBookComponent } from './views/admin/pages/Notes/note-book/note-book.component';
import { NoteIndexComponent } from './views/admin/pages/Notes/note-index/note-index.component';
import { ClassroomProfessorListComponent } from './views/professor-module/pages/classroom-professor-list/classroom-professor-list.component';
import { ClassroomStudentsListComponent } from './views/professor-module/pages/classroom-students-list/classroom-students-list.component';
import { EducationalForumComponent } from './views/professor-module/pages/educational/educational-forum/educational-forum.component';
import { EducationalResourceComponent } from './views/professor-module/pages/educational/educational-resource/educational-resource.component';
import { FollowUpComponent } from './views/professor-module/pages/follow-up/follow-up.component';
import { NoteAppriciationComponent } from './views/professor-module/pages/notes/note-appriciation/note-appriciation.component';
import { NoteCreateComponent } from './views/professor-module/pages/notes/note-create/note-create.component';
import { PresenceBookComponent } from './views/professor-module/pages/Presence/presence-book/presence-book.component';
import { PresenceCreateComponent } from './views/professor-module/pages/Presence/presence-create/presence-create.component';
import { PresenceDetailsComponent } from './views/professor-module/pages/Presence/presence-details/presence-details.component';
import { ProfessorAccountComponent } from './views/professor-module/pages/professor-account/professor-account.component';
import { ProfessorBulletinAppreciationComponent } from './views/professor-module/pages/professor-bulletin-appreciation/professor-bulletin-appreciation.component';
import { ProfessorBulletinComponent } from './views/professor-module/pages/professor-bulletin/professor-bulletin.component';
import { ProfessorPersonalListComponent } from './views/professor-module/pages/professor-personal-list/professor-personal-list.component';
import { ProfessorStudentTaskViewComponent } from './views/professor-module/pages/professor-student-task-view/professor-student-task-view.component';
import { ProfessorTaskListComponent } from './views/professor-module/pages/professor-task-list/professor-task-list.component';
import { TextbookComponent } from './views/professor-module/pages/textbook/textbook.component';
import { TimeTableComponent } from './views/professor-module/pages/time-table/time-table.component';
import { ProfessorCourseComponent } from './views/admin/pages/professors/professor-course/professor-course.component';
import { BulletinGeneretedComponent } from './views/admin/pages/Notes/bulletin-genereted/bulletin-genereted.component';
import { BulletinValidationComponent } from './views/admin/pages/Notes/bulletin-validation/bulletin-validation.component';
import { BulletinComponent } from './views/admin/pages/Notes/bulletin/bulletin.component';
import { ProfessorClassroomComponent } from './views/admin/pages/professors/professor-classroom/professor-classroom.component';
import { ProfessorComponent } from './views/admin/pages/professors/professor/professor.component';
import { TimetableComponent } from './views/admin/pages/timetable/timetable.component';
import { FollowedArchievementComponent } from './views/admin/pages/Notes/followed-archievement/followed-archievement.component';
import { CompositionByClassroomComponent } from './views/admin/pages/Notes/composition-by-classroom/composition-by-classroom.component';
import { CompositionIndexComponent } from './views/admin/pages/Notes/composition-index/composition-index.component';
import { NotebookProfessorComponent } from './views/admin/pages/Notes/notebook-professor/notebook-professor.component';
import { StudentAttendanceComponent } from './views/admin/pages/Bvs/student-attendance/student-attendance.component';
import { StudentDispensationComponent } from './views/admin/pages/Bvs/student-dispensation/student-dispensation.component';
import { AttendanceBookComponent } from './views/admin/pages/Bvs/Attendances/attendance-book/attendance-book.component';
import { AttendanceCreateComponent } from './views/admin/pages/Bvs/Attendances/attendance-create/attendance-create.component';
import { AttendanceDetailsComponent } from './views/admin/pages/Bvs/Attendances/attendance-details/attendance-details.component';
import { RequestPermissionIndexComponent } from './views/admin/pages/Bvs/RequestPermissions/request-permission-index/request-permission-index.component';
import { SanctionIndexComponent } from './views/admin/pages/Bvs/sanction-index/sanction-index.component';
import { HealthControlComponent } from './views/admin/pages/Infirmary/health-control/health-control.component';
import { HealthComponent } from './views/admin/pages/Infirmary/health/health.component';
import { VaccinationComponent } from './views/admin/pages/Infirmary/vaccination/vaccination.component';
import { TextBookComponent } from './views/admin/pages/text-book/text-book.component';
import { PaymentMethodComponent } from './views/admin/pages/financial/payment-method/payment-method.component';
import { FactureComponent } from './views/admin/pages/financial/facture/facture.component';
import { PaymentComponent } from './views/admin/pages/financial/payment/payment.component';
import { SchoolReminderComponent } from './views/admin/pages/financial/school-reminder/school-reminder.component';
import { TransactionComponent } from './views/admin/pages/financial/transaction/transaction.component';
import { MissingPersonalComponent } from './views/admin/pages/RH/missing-personal/missing-personal.component';
import { PersonalVacationRequestComponent } from './views/admin/pages/RH/personal-vacation-request/personal-vacation-request.component';
import { RecruitmentMembderComponent } from './views/admin/pages/RH/recruitment-membder/recruitment-membder.component';
import { RecruitmentOfferComponent } from './views/admin/pages/RH/recruitment-offer/recruitment-offer.component';
import { RecruitmentWorkflowComponent } from './views/admin/pages/RH/recruitment-workflow/recruitment-workflow.component';
import { RHGeneralParameterComponent } from './views/admin/pages/RH/rhgeneral-parameter/rhgeneral-parameter.component';
import { SalaryGridComponent } from './views/admin/pages/RH/salary-grid/salary-grid.component';
import { SalaryPaymentComponent } from './views/admin/pages/RH/salary-payment/salary-payment.component';
import { BudgetComponent } from './views/admin/pages/financial/budget/budget.component';
import { ClaimComponent } from './views/admin/pages/financial/claim/claim.component';
import { ExpenseComponent } from './views/admin/pages/financial/expense/expense.component';
import { PersonalContratComponent } from './views/admin/pages/personal-contrat/personal-contrat.component';
import { RecruitmentListComponent } from './views/public/recruitment/recruitment-list.component';
import { RecruitmentDetailComponent } from './views/public/recruitment/recruitment-detail.component';
import { DocumentComponent } from './views/admin/pages/configurations/document/document.component';
import { BackupComponent } from './views/admin/pages/configurations/backup/backup.component';
import { InscriptionFileComponent } from './views/admin/pages/configurations/inscription-file/inscription-file.component';

export const routes: Routes = [
    {path: '', redirectTo: '/login',pathMatch:'full'},
    {
        path:"admin",
        component:LayoutComponent,
        canActivate:[AuthGuard,VerifyAccountStateGuard],
        children:[
              //Dashboard
              {
                path:"dashboard",
                component:HomeComponent
              },


             //Configurations
              {
                path:"configurations/academic-year",
                component:AcademicYearComponent
              },
              {
                path:"configurations/academic-year-closure/:id",
                component:AcademicYearClosureComponent
              },
              {
                path:"configurations/school",
                component:SchoolComponent
              },
              {
                path:"configurations/settings",
                component:SettingComponent
              },
              {
                path:"configurations/cycles",
                component:CycleComponent
              },
              {
                path:"configurations/courses",
                component:CourseComponent
              },
              {
                path:"configurations/rooms",
                component:RoomComponent
              },
              {
                path:"configurations/periods",
                component:PeriodComponent
              },
              {
                path:"configurations/stop-notes",
                component:StopNoteComponent
              },
              {
                path:"configurations/category-informations",
                component:CategoryInformationComponent
              },
              {
                path:"configurations/useful-informations",
                component:UsefulInformationComponent
              },
              {
                path:"configurations/agendas",
                component:AgendaComponent
              },
              {
                path:"configurations/polls",
                component:PollComponent
              },
              {
                path:"configurations/classroom-passations",
                component:ClassroomPassationComponent
              },
              {
                path:"configurations/classroom-type-fees",
                component:ClassroomTypeFeeComponent
              },
              {
                path:"configurations/type-fees",
                component:TypeFeeComponent
              },
              {
                path:"configurations/levels",
                component:LevelComponent
              },
              {
                path:"configurations/classrooms",
                component:ClassroomComponent
              },
              {
                path:"configurations/templates",
                component:TemplateComponent
              },
              {
                path:"configurations/inscription-validations",
                component:InscriptionValidationComponent
              },
              {
                path:"configurations/payment-methods",
                component:PaymentMethodComponent
              },
              {
                path:"configurations/documents",
                component:DocumentComponent
              },
              {
                path:"configurations/backups",
                component:BackupComponent
              },
              {
                path:"configurations/inscription-files",
                component:InscriptionFileComponent
              },
              {
                path:"transactions",
                component:TransactionComponent
              },
              {
                path:"factures",
                component:FactureComponent
              },
              {
                path:"payments",
                component:PaymentComponent
              },
              {
                path:"school-reminders",
                component:SchoolReminderComponent
              },

              //bvs

              {
                path:"bvs-attendances-create",
                component:AttendanceCreateComponent
              },
              {
                path:"bvs-attendances-book",
                component:AttendanceBookComponent
              },
              {
                path:"bvs-attendances-details/:code",
                component:AttendanceDetailsComponent
              },
              {
                path:"bvs-request-permissions/index",
                component:RequestPermissionIndexComponent
              },
        
              {
                path:"bvs-sanctions/index",
                component:SanctionIndexComponent
              },

              //infirmerie

              {
                path:"infimary-healths",
                component:HealthComponent
              },
              {
                path:"infimary-health-controls",
                component:HealthControlComponent
              },
              {
                path:"infimary-vacctinations",
                component:VaccinationComponent
              },
              {
                path:"textbooks",
                component:TextBookComponent
              },
        

              //INSCRIPTIONS
              {
                path:"inscription",
                component:InscriptionComponent
              },
              {
                path:"inscription-create",
                component:InscriptionCreateComponent
              },
              {
                path:"inscription-renew",
                component:InscriptionRenewComponent
              },
              {
                path:"inscription-details/:code",
                component:InscriptionDetailComponent
              },
              {
                path:"inscription-renew-details/:code",
                component:InscriptionRenewDetailsComponent
              },

              //STUDENTS
              {
                path:"students",
                component:StudentComponent
              },

              //INQUERIES
              {
                path:"inqueries/index/:type",
                component:InqueryIndexComponent
              },
              {
                path:"inqueries-parcours",
                component:InqueryParcoursComponent
              },
              {
                path:"inquery-details/:code",
                component:InqueryDetailsComponent
              },
        

              {
                path:"user-account",
                component:UserProfilComponent
              },
              {
                path:"user-settinngs",
                component:UserSettingComponent
              },
              {
                path:"configurations/personals",
                component:PersonalComponent
              },
              {
                path:"features",
                component:FeatureComponent
              },
              {
                path:"users",
                component:UserComponent
              },
              {
                path:"roles",
                component:RoleComponent
              },
              {
                path:"permissions",
                component:PermissionComponent
              },
              {
                path:"profiles",
                component:ProfileComponent
              },
              {
                path:"profiles/:id",
                component:WindowsComponent
              },


              {
                path:"professors/courses",
                component:ProfessorCourseComponent
              },

              {
                path:"professors/list",
                component:ProfessorComponent
              },
              {
                path:"professors/classrooms",
                component:ProfessorClassroomComponent
              },
              {
                path:"timetable",
                component:TimetableComponent
              },
              {
                path:"bulletins",
                component:BulletinComponent
              },
              {
                path:"bulletins-generated",
                component:BulletinGeneretedComponent
              },
              {
                path:"bulletin-validations",
                component:BulletinValidationComponent
              },
              {
                path:"followed-archievements",
                component:FollowedArchievementComponent
              },

              {
                path:"note-index",
                component:NoteIndexComponent
              },
              {
                path:"note-book",
                component:NoteBookComponent
              },
              {
                path:"note-book-professor",
                component:NotebookProfessorComponent
              },
              {
                path:"note-index/:id",
                component:NoteIndexComponent
              },
              {
                path:"composition-index",
                component:CompositionIndexComponent
              },
              {
                path:"composition-by-classrooms",
                component:CompositionByClassroomComponent
              },
              {
                path:"student-attendances",
                component:StudentAttendanceComponent
              },
              {
                path:"student-dispensations",
                component:StudentDispensationComponent
              },

              //RH
               {
        path:"rh/missing-personals",
        component:MissingPersonalComponent
      },
      {
        path:"rh/personal-vacation-requests",
        component:PersonalVacationRequestComponent
      },
      {
        path:"rh/recuitment-members",
        component:RecruitmentMembderComponent
      },
      {
        path:"rh/recuitment-workflows",
        component:RecruitmentWorkflowComponent
      },
      {
        path:"rh/recuitment-offers",
        component:RecruitmentOfferComponent
      },
      {
        path:"rh/recuitment-memebers",
        component:RecruitmentMembderComponent
      },
      {
        path:"rh/general-parameter",
        component:RHGeneralParameterComponent
      },
      {
        path:"rh/salary-grids",
        component:SalaryGridComponent
      },
      {
        path:"rh/salary-payments",
        component:SalaryPaymentComponent
      },
//comptability


  {
        path:"claims",
        component:ClaimComponent
      },
      {
        path:"budgets",
        component:BudgetComponent
      },
      {
        path:"expenses",
        component:ExpenseComponent
      },
      {
        path:"personal-contracts",
        component:PersonalContratComponent
      }

                  ]
    },

    {
      path:"professor-panel",
      component:LayoutProfessor,
      canActivate:[AuthGuard,VerifyAccountStateGuard],
      children:[
        {
          path:"accueil",
          component:HomeProfessor
        },
        {
          path:"timetables",
          component:TimeTableComponent
        },
        {
          path:"claasroom-students-list",
          component:ClassroomStudentsListComponent
        },
        {
          path:"classroom-professors-list",
          component:ClassroomProfessorListComponent
        },
        {
          path:"professors-personal-list",
          component:ProfessorPersonalListComponent
        },
        {
          path:"professors-appreciation",
          component:NoteAppriciationComponent
        },
        {
          path:"professors-bulletin",
          component:ProfessorBulletinComponent
        },
        {
          path:"professors-bulletin-appreciation",
          component:ProfessorBulletinAppreciationComponent
        },
        {
          path:"professors-account",
          component:ProfessorAccountComponent
        },
        {
          path:"educational-resources",
          component:EducationalResourceComponent
        },
        {
          path:"educational-forum",
          component:EducationalForumComponent
        },
        {
          path:"textbook",
          component:TextbookComponent
        },
        {
          path:"tasklists",
          component:ProfessorTaskListComponent
        },
        {
          path:"tasklists-student-view",
          component:ProfessorStudentTaskViewComponent
        },
        {
          path:"note-create",
          component:NoteCreateComponent
        },
        {
          path:"note-create/:save",
          component:NoteCreateComponent
        },
        {
          path:"note-create/:id",
          component:NoteCreateComponent
        },
        {
          path:"note-index",
          component:NoteIndexComponent
        },
        {
          path:"note-book",
          component:NoteBookComponent
        },
        {
          path:"attendances",
          component:PresenceBookComponent
        },
        {
          path:"attendances/:code",
          component:PresenceDetailsComponent
        },
        {
          path:"attendance-create",
          component:PresenceCreateComponent
        },
        {
          path:"follow-up",
          component:FollowUpComponent
        }
      ]
    },

    //Authentification
    {
      path:"activate-account",
      component:AccountActivationComponent,
      canActivate:[IsVerifiedAccountStateGuard]
    },
    {
      path:"login",
      component:LoginComponent,
      canActivate:[IsAuthedGuard]
    },
    {
      path:"forget-password",
      component:ForgetPasswordComponent
    },
    {
      path:"recovery-password/:token",
      component:RecoveryPasswordComponent
    },

    //Section publique recrutement (sans authentification)
    {
      path:"recrutement",
      component:RecruitmentListComponent
    },
    {
      path:"recrutement/:id",
      component:RecruitmentDetailComponent
    },

    {path: '404', component: NotFoundComponent},
    {path: '**', redirectTo: '/404'}
];
